/** The only functions an admin-authored formula may call. */
export const FUNCTIONS = [
    'IF', 'AND', 'OR', 'NOT', 'ISBLANK', 'INDEX', 'MROUND', 'LEN', 'TODAY', 'CELLIMAGE',
];
/** Error sentinels (Smartsheet-compatible where they overlap). */
export const ERR = {
    PARSE: '#UNPARSEABLE',
    REF: '#INVALID REF',
    DIVIDE: '#DIVIDE',
    CYCLE: '#CIRCULAR REF',
    FUNC: '#UNSUPPORTED FN',
};
/** True when a value is an error sentinel. */
export function isFormulaError(v) {
    return typeof v === 'string' && /^#[A-Z]/.test(v);
}
/** True when a value is BLANK (unset / empty string). */
export function isBlank(v) {
    return v === null || v === undefined || v === '';
}
//# sourceMappingURL=types.js.map